import * as types from './Notifications.types';

export const addNotification = (data) => ({
  type: types.ADD_NOTIFICATION,
  data,
});
